import { defineStore } from 'pinia'
import { weeklyStorage, sharedKeyPersist } from './persistence'

export const useUserFlagsStore = defineStore('userFlags', {
	state: () => ({
		/**
		 * Remote user flags are stored in the backend. These flags are used to control state of user's profile.
		 * @type {Object}
		 */
		remote: {},
		/**
		 * Local user flags are stored in the frontend and synced with localStorage.
		 */
		local: {
			freebieAccess: false,

			isGdprPassed: false,

			cancellationFeeType: null,
			brazeAssessmentEmailSent: false,
			commitmentCancellationFlowPassed: false,

			applyDiscountOnAbort: false,

			scratchCardPassed: false,
			scratchCardDiscountApplied: false,

			goldenTicketRevealed: false,
		},
	}),

	getters: {
		getFlags(state) {
			return {
				remote: state.remote,
				local: state.local,
			}
		},
		/**
		 * Check if any of the flags is greater than current time.
		 * This needs for checking if user has possibility to do some actions.
		 * @param {Array<string>|string} flags
		 * @returns {boolean}
		 */
		isAnyOfFlagsAfterCurrentTime: (state) => (flags) => {
			if (typeof flags === 'string') {
				flags = [flags]
			}

			for (const flag of flags) {
				const remoteFlag = state.remote[flag]

				if (Number.isInteger(remoteFlag) && remoteFlag > Date.now()) {
					return true
				}
			}

			return false
		},
	},

	actions: {
		setRemoteFlags(flags) {
			this.remote = flags
		},
		updateLocalFlags(payload) {
			this.local = { ...this.local, ...payload }
		},
	},

	persist: sharedKeyPersist('vuex', 'userFlags', weeklyStorage),
})
